export default __webpack_public_path__ + "static/media/errorTooltip.cb0d1c7b.svg";